var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-input-location',{attrs:{"value":_vm.location,"label":"Localisation*","lazy":"","coordinate-format":_vm.coordinateFormat},on:{"input":_vm.input}})
}
var staticRenderFns = []

export { render, staticRenderFns }